<template>
  <div>
    <business-list v-show="tabType === 1" @handleShow="handleShow" />
    <business-show v-if="tabType === 2" :rowId="id" :from="from" @handleShow="handleShow"/>
  </div>
</template>

<script>
import businessList from './list.vue'
import businessShow from './show.vue'
export default {
  components: { businessList,businessShow },
  data() {
    return {
      tabType: 1,
      id: null,
      from: null
    }
  },
  created() {
    // 检查路由参数，如果有 id 则直接显示详情页
    if (this.$route.query.id) {
      this.tabType = 2
      this.id = this.$route.query.id
      this.from = this.$route.query.from
    }
  },
  watch: {
    '$route.query': function(newQuery) {
      if (newQuery.id) {
        this.tabType = 2
        this.id = newQuery.id
        this.from = newQuery.from
      }
    }
  },
  methods: {
    handleShow(id, type) {
      this.tabType=type
      this.id = id
      console.log('id: ',id);
    }
  }
}
</script>

<style>

</style>
